import type { ConveyedPersonAction } from "../types/involvement.js";

/**
 * Whether what is conveyed over a record lets its holder end a guest's
 * access: whoever may involve a guest (`involve_guest`) or decides who is
 * involved (`assign`). Derived from both rather than conveyed, so it follows
 * them wherever they are granted.
 */
export const mayEndGuestAccess = (
  conveyed: readonly ConveyedPersonAction[],
): boolean => conveyed.includes("involve_guest") || conveyed.includes("assign");
